module.exports = __webpack_public_path__ + "static/media/signup-page-freelancer-3.9c75134b.webp";